import React from "react";
import Control from "../../common/Control";
import SaveBtn from "../../common/SaveBtn";

const FastEpBlock = ({
  actions,
  isLoadingAction,
  fastEpFileName,
  setFastEpFileName,
  errors,
}) => {
  return (
    <>
      <h5 className="mt-4 mb-2">Allocataires EP depuis FAST</h5>
      <ul className="list-group">
        <li className="list-group-item d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-start flex-column">
            Récupère le fichier spécifié depuis FAST et le traite
            <Control
              className="w-100 px-0"
              type="text"
              placeholder="nom du fichier (sans le .csv)"
              value={fastEpFileName}
              name="fastFileName"
              change={(e) => setFastEpFileName(e.target.value)}
              error={errors}
            />
            <p className="text-muter">ex : allocEP-YMD</p>
          </div>
          <div className="d-center flex-row">
            {fastEpFileName && fastEpFileName.length && (
              <SaveBtn
                type="btn-success"
                margin=""
                save={() => actions.import.ep()}
                isSaving={isLoadingAction.includes("ep")}
                text={
                  <div className="d-center">
                    <i className="fa fa-file-import mr-2" />
                    Importer
                  </div>
                }
              />
            )}
          </div>
        </li>
      </ul>
    </>
  );
};

export default FastEpBlock;
